import {IDataCategory as IGVLDataCategory, IPurpose as IGVLPurposeInfo, VendorList} from "./vendor-list";
import cmp from "../context/context";

export class DataCategory {
    /* STATIC */

    public static build(dataCategoryId: number) : DataCategory|null {
        const gvlDataCategory: IGVLDataCategory|undefined = cmp().vendorList?.getDataCategoryInfo(dataCategoryId);
        if (gvlDataCategory) {
            return new DataCategory(gvlDataCategory);
        }
        return null;
    }

    /* INSTANCE */
    private constructor(private readonly _gvlDataCategoryInfo: IGVLDataCategory) {
    }

    public get id() : number {
        return this._gvlDataCategoryInfo.id;
    }

    public get name() : string {
        return this._gvlDataCategoryInfo.name;
    }

    public get description() : string {
        return this._gvlDataCategoryInfo.description;
    }
}
